<template>
  <div class="add">
    <basic-container>
      <div class="add-header">
        <div class="left-title">{{form.id?'编辑':'新增'}}</div>
        <el-button
          size="small"
          plain
          type="primary"
          style="
            margin-right: 20px;
            margin-bottom: 0;
            background: #fff;
          "
          @click="back"
        >
          返回
        </el-button>
      </div>
      <avue-form
        :option="option"
        ref="garbageForm"
        v-model="form"
        @submit="submit"
      >
        <template slot="map" slot-scope="{ type }">
    

          <div>
            <el-amap-search-box
              class="search-box"
              v-if="type != 'view'"
              :search-option="searchOption"
              :on-search-result="onSearchResult"
            >
            </el-amap-search-box>
          </div>
          <el-amap
            vid="amapDemo"
            :center="center"
            :amap-manager="amapManager"
            :zoom="zoom"
            :events="events"
            class="amap-demo"
            style="width: 640px; height: 360px"
          >
            <el-amap-marker
              ref="marker"
              vid="component-marker"
              :position="marker.position"
              :events="marker.events"
              :visible="marker.visible"
              :draggable="marker.draggable"
            ></el-amap-marker>
          </el-amap>
        </template>
      </avue-form>
    </basic-container>
  </div>
</template>

<script>
import { tableOption } from "./addGarbage";
import { AMapManager } from "vue-amap";
const amapManager = new AMapManager();
import { addObj,putObj,checkExistsProject } from "@/api/chain/garbage";
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      option: tableOption(this),
      form: {},
      searchOption: {
        // 限制搜索城市的范围
        citylimit: false,
      },
      zoom: 14,
      center: [113.98074, 22.55251],
      marker: {
        position: [113.98074, 22.55251],
        visible: true,
        draggable: false,
      },
      amapManager,
      events: {
        click: (e) => {
          console.log(e);
          // this.mapInfo.lng = e.lnglat.lng;
          // this.mapInfo.lat = e.lnglat.lat;
          // this.mapInfo.lnglat = [e.lnglat.lng, e.lnglat.lat];
          this.marker.position = [e.lnglat.lng, e.lnglat.lat];
          this.form.fence = e.lnglat.lng + "," + e.lnglat.lat;
        },
      },
    };
  },
   computed:{
    ...mapGetters(['tagList']),
  },
  created(){
    console.info(JSON.parse(this.$route.query.row))
    if(this.$route.query.row){
      this.form=JSON.parse(this.$route.query.row)
      if(this.form.city){
        this.form.city =this.form.city.split(',')
      }
    }else{
      this.form={}
    }
  },
  methods: {
    async handleUpdate(row, done, ) {
      console.log(row);
      row.soilTypes =
        Array.isArray(row.soilTypes) && row.soilTypes.length > 0
          ? row.soilTypes.join(",")
          : row.soilTypes || "";
      let message = "";
      if (row.isDel == 1) {
        message = await checkExistsProject(row.id).then((res) => {
          return res.data.data;
        });
      }
      if (message != "") {
        this.$confirm(message, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.putObj(row, done);
          })
          .catch((err) => {
            done()
            // loading();
          });
      } else {
        this.putObj(row, done);
      }
    },
    putObj(row, done) {
      putObj(row)
        .then((response) => {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
          done();
           let { tag } = this.findTag(this.$route.path);
          this.$store.commit("DEL_TAG", tag);
          this.back();
          // this.getPage(this.page);
        })
        .catch(() => {
          // loading();
        });
    },
    findTag(value) {
      let tag, key;
      this.tagList.map((item, index) => {
        if (item.value === value) {
          tag = item;
          key = index;
        }
      });
      return { tag: tag, key: key };
    },
    submit(row, done) {
      // row.city=row.city.join(',')

      if(row.id){
       return this.handleUpdate(row, done)
      }
      row.soilTypes =
        Array.isArray(row.soilTypes) && row.soilTypes.length > 0
          ? row.soilTypes.join(",")
          : row.soilTypes || "";
          row.garbageType="固定消纳场"
      addObj(row)
        .then((response) => {
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success",
          });
          done();
          let { tag } = this.findTag(this.$route.path);
          this.$store.commit("DEL_TAG", tag);
          this.back();
        })
        .catch(() => {
          done();
        });
    },
    back() {
      this.$router.push({
        path: "/chain/project/garbage2",
      });
    },
    onSearchResult(pois) {
      this.center = [pois[0].location.lng, pois[0].location.lat];
      this.marker.position = [pois[0].location.lng, pois[0].location.lat];
      this.form.fence = pois[0].location.lng + "," + pois[0].location.lat;
    },
  },
};
</script>

<style lang="scss" scoped>
.search-box {
  position: absolute;
  top: 12px;
  left: 12px;
}
/deep/.el-radio__input.is-checked .el-radio__inner {
  background: #fff;
  &::after {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #35b1ff;
  }
}
.add-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  .left-title {
    font-weight: 500;
    font-size: 16px;
    color: #313133;
  }
}
.submit {
  border-top: 1px solid #ededf0;
  padding-top: 8px;
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: 0px;
  background: #fff;
  margin: 0 10px;
  right: -1px;
  z-index: 9999;
  padding-bottom: 35px;
}
// /deep/.avue-form__group .el-col{
//   border-top: 1px solid #ededf0;
// }
</style>